/**
 * 줄 작업 단추 — 아이콘 하나에 짧은 툴팁(2026-10-20).
 *
 * 목록 줄마다 [편집]·[중지]·[보관] 같은 글자 단추를 늘어놓으면 줄마다 글자가 쌓여 목록이 읽히지 않고, 줄마다 단추 폭이
 * 달라 열이 들쭉날쭉했다. 통합 관제 서버 목록처럼 아이콘 단추로 둔다 — 마우스를 올리면 짧은 이름(`title` — "편집")이,
 * 화면 낭독기에는 무엇의 작업인지(`aria-label` — "가을 행사 편집")가 읽힌다. [⋯] 메뉴(`MoreMenu`)와 같은 크기다.
 *
 * 되돌리기 어려운 작업(`danger`)은 평소에는 다른 단추와 같은 색이고, 마우스를 올리면 빨갛게 — 줄마다 빨간 단추가
 * 늘어서지 않게.
 */
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

export function IconButton({
  icon: Icon,
  label,
  subject,
  danger = false,
  className,
  ...rest
}: Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'aria-label'> & {
  icon: LucideIcon;
  /** 작업 이름 — 툴팁에 그대로 보인다("편집"). */
  label: string;
  /** 무엇의 작업인가 — 화면 낭독기에 이름 앞에 붙여 읽힌다("가을 행사"). */
  subject?: string;
  danger?: boolean;
}): ReactNode {
  return (
    <button
      type="button"
      title={label}
      {...rest}
      className={`btn btn-tiny btn-icon${danger ? ' is-danger' : ''}${className ? ` ${className}` : ''}`}
      aria-label={subject ? `${subject} ${label}` : label}
    >
      <Icon className="h-3.5 w-3.5" strokeWidth={2} aria-hidden="true" />
    </button>
  );
}
